export default __webpack_public_path__ + "static/media/hht1_ani_16.91ea4639.png";